const hasData = (count: number) => {
    return count >= 1
}

export default hasData
